import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import { fetchFormData, fetchData } from "../../utils/options";
import topTost from "../../utils/topTost";
import TextArea from "../shared/TextArea";
import { BaseUrl } from "../..";
const SemesterCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [courseOptions, setCourseOptions] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    course_id: "",
    status: "1",
    orderby: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!localStorage.getItem("access_token")) {
      navigate("/");
    }
  }, []);

  const handleChange = (key, value) => {
    if(key === "orderby"){
      value=value.replace(/[^0-9]/g,"")
    }
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const fetchCourses = async () => {
    try {
      const result = await fetchData("course-dropdown", {}, "POST");

      if (result?.success && Array.isArray(result.data)) {
        const options = result.data.map((item) => ({
          label: item.title,
          value: item.id,
        }));

        setCourseOptions(options);
      }
    } catch (error) {
      console.error("Failed to load courses:", error);
    }
  };

  const fetchAllDetails = async (id) => {
    try {
      const result = await fetchData(
        `semester-details/${id}`,
        formData,
        "POST"
      );

      if (result?.success && result?.data) {
        const d = result.data;

        setFormData({
          id: d.id,
          title: d.title || "",
          course_id: d.course_id || "", // <-- Add course_id here
          description: d.description || "",
          status: d.status?.toString() || "1",
          orderby: d.orderby || "",
        });
      } else {
        topTost({ title: "Semester not found", icon: "warning" });
      }
    } catch (error) {
      console.log("Fetch error:", error);
      topTost({ title: "Server error", icon: "error" });
    }
  };

  useEffect(() => {
    if (id) {
      fetchAllDetails(id);
    }
    fetchCourses();
  }, [id]);

 const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  const form = new FormData();
  Object.entries(formData).forEach(([key, value]) => {
    form.append(key ?? "", value ?? "");
  });

  try {
    const token = localStorage.getItem("access_token");
    const response = await fetch(
      id ? `${BaseUrl}semester/update/${id}` : `${BaseUrl}insert-semester`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: form,
      }
    );

    const data = await response.json();
    const result = data.result;
    if (!result) return;

    // Handle validation errors
      if (result?.errors) {
      const firstField = Object.keys(result.errors)[0];
      const errorMsg = result.errors[firstField][0];
      topTost({ title: errorMsg, icon: "error" });
      setIsSubmitting(false);
      return;
    }
    // Handle success
    if (
      result?.success === "true" ||
      result?.success === true ||
      result?.code === 200 ||
      result?.code === "200"
    ) {
      topTost({
        title: result.message || (id ? "Updated successfully!" : "Saved successfully!"),
        icon: "success",
      });
      setTimeout(() => {
            navigate("/master/semester-list");
      }, 600);
  
      setIsSubmitting(false);
      return;
    }

    // Handle other errors
    topTost({
      title: result?.message || "Error submitting form",
      icon: "error",
    });
  } catch (error) {
    topTost({ title: "Error submitting form", icon: "error" });
    console.error("Submit error:", error);
  } finally {
    setIsSubmitting(false);
  }
};



  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-3 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                {id ? "Edit Semester:" : "Add Semester:"}
              </h5>
            </div>
            <form onSubmit={handleSubmit} className="p-3 ">
              <div className="mb-3 row align-items-center">
                <label
                  htmlFor="course-select"
                  className="col-lg-2 col-md-2 col-sm-4 fw-semibold"
                >
                  Course Select: <span className="text-danger">*</span>
                </label>
                <div className="col-lg-6 col-md-6 col-sm-8">
                  <SelectDropdown
                    id="course-select"
                    name="course_id"
                    value={formData.course_id}
                    onSelectOption={(option) =>
                      handleChange("course_id", option.value)
                    }
                    options={courseOptions}
                    placeholder="Select an option"
                    icon="fa-opera"
                    required
                  />
                </div>
              </div>

              <Input
                label="Semester"
                name="title"
                placeholder="Enter Semester "
                value={formData.title}
                onChange={handleChange}
                icon="feather-archive"
                required
              />

              <Input
                label="Order No"
                name="orderby"
                placeholder="Enter Order "
                value={formData.orderby}
                onChange={handleChange}
                icon="feather-hash"
                required
              />

              <div className="mt-4 customButton">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SemesterCreate;
